module.exports = __webpack_public_path__ + "img/alert_sent.8029a286.svg";